/**
 * Restructed by he.zhikai
 * Restructed on 2017-11-09
 */
'use strict';
angular.module('passReportsModule', []).
controller('confirmPassReportsCtrl', ["$scope", "$filter","$q", "$state", "$modalInstance", "commandService", "trsspliceString", "repSummService", "modalDialog", "report", "groupid", "groupname",
    function($scope, $filter,$q, $state, $modalInstance, commandService, trsspliceString, repSummService, modalDialog, report, groupid, groupname) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                report: report,
                groupid: groupid,
                groupname: groupname,
                channels: ['文字', '图片', '视频', '直播', '可视化', 'H5', 'AR'],
                tags: [{
                    "value": "1",
                    "label": "普通"
                }, {
                    "value": "2",
                    "label": "重要"
                }, {
                    "value": "3",
                    "label": "紧急"
                }, {
                    "value": "4",
                    "label": "敏感"
                }]
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            packageOneReport();
        }

        /**
         * [packageOneReport description] 对报题数据进行处理
         * @return {[type]}      [description]
         */
        function packageOneReport() {
            var item = $scope.data.report;
            //整理执行人
            item.departs = [];
            if(item.EXECUTOR.length>0) {
                item.departs.push(item.EXECUTOR[0]);
                item.departs[0].users = [item.EXECUTOR[0].USERNAME];
                for(var i=1;i<item.EXECUTOR.length;i++) {
                    for(var j=0;j<item.departs.length;j++) {
                        if(item.EXECUTOR[i].GNAME==item.departs[j].GNAME) {
                            item.departs[j].users.push(item.EXECUTOR[i].USERNAME);
                            break;
                        } else if(j+1==item.departs.length) {
                            item.departs.push(item.EXECUTOR[i]);
                            item.departs[j+1].users=[item.EXECUTOR[i].USERNAME];
                            break;
                        }
                    }
                }
            }
            //整理发稿渠道
            var metaObj = item.METATYPEINFO[0];
            item.metatypeApp = metaObj.METATYPEBYAPP ? metaObj.METATYPEBYAPP.split(',').map(function(idx) {
                return $scope.data.channels[parseInt(idx) - 1];
            }).concat(metaObj.METATYPEBYAPPOTHER ? [metaObj.METATYPEBYAPPOTHER] : []).join('、') : (metaObj.METATYPEBYAPPOTHER ? [metaObj.METATYPEBYAPPOTHER] : []).join('、');
            item.metatypeWeb = metaObj.METATYPEBYWEB ? metaObj.METATYPEBYWEB.split(',').map(function(idx) {
                return $scope.data.channels[parseInt(idx) - 1];
            }).concat(metaObj.METATYPEBYWEBOTHER ? [metaObj.METATYPEBYWEBOTHER] : []).join('、') : (metaObj.METATYPEBYWEBOTHER ? [metaObj.METATYPEBYWEBOTHER] : []).join('、');
            item.metatypePaper = metaObj.METATYPEBYPAPER ? metaObj.METATYPEBYPAPER.split(',').map(function(idx) {
                return $scope.data.channels[parseInt(idx) - 1];
            }).concat(metaObj.METATYPEBYPAPEROTHER ? [metaObj.METATYPEBYPAPEROTHER] : []).join('、') : (metaObj.METATYPEBYPAPEROTHER ? [metaObj.METATYPEBYPAPEROTHER] : []).join('、');
            item.metatypeOther = metaObj.METATYPEBYOTHER;
        }

        /**
         * [showDate description] 显示持续时间
         * @return {[type]} [description]
         */
        $scope.showDate = function() {
            var startDate = $filter('date')(new Date($scope.data.report.STARTTIME), "yyyy-MM-dd").toString();
            var endDate = $filter('date')(new Date($scope.data.report.ENDTIME), "yyyy-MM-dd").toString();
            return startDate + " 至 " + endDate;
        };

        /**
         * [close description] 取消
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };

        /**
         * [editReport description] 编辑报题
         * @return {[type]} [description]
         */
        $scope.editReport = function() {
            commandService.newInvoke('checkLock', { ReportId: $scope.data.report.NEWREPORTID }).then(function(res) {
                if (res.ISLOCK === 'true') {
                    modalDialog.alertType('报题处于编辑状态,是否强制编辑?', '', 'warning', true, function() {
                        foreEditReport(report, function() {
                            editReport($scope.data.groupid, $scope.data.report.NEWREPORTID);
                        });
                    });
                } else {
                    editReport($scope.data.groupid, $scope.data.report.NEWREPORTID);
                }
            });
        };

        /**
         * [foreEditReport description] 强制编辑报题
         * @param  {[type]}   report   [description] 当前报题
         * @param  {Function} callback [description] 跳转到报题编辑页面
         * @return {[type]}            [description]
         */
        function foreEditReport(report, callback) {
            commandService.newInvoke('forcedUnLockReport', { ReportId: $scope.data.report.NEWREPORTID }).then(function(res) {
                if (res.ISSUCCESS === 'true') {
                    callback();
                }
            });
        }
        /**
         * [getQueryChannels description] 获取发稿渠道
         * @param  {[type]} GroupId [description] 报题id
         * @return {[type]}          [description]
         */
        function getQueryChannels(id) {
            var defer = $q.defer();
            commandService.newInvoke('queryChannels', { GroupId: id }).then(function(data) {
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [editReport description] 编辑报题
         * @param  {[type]} reportId [description] 报题id
         * @return {[type]}          [description]
         */
        function editReport(groupid, reportId) {
            getQueryChannels(groupid).then(function(res) {
                var channelsData = res;
                repSummService.createNewReport(groupid, reportId,channelsData).then(function() {});
                $modalInstance.dismiss();
            });

        }

        /**
         * [confirm description] 审批通过
         * @return {[type]}      [description]
         */
        $scope.confirm = function() {
            $modalInstance.close({ ReportId: $scope.data.report.NEWREPORTID, ReportType: $scope.data.report.REPORTTYPE });
        };

    }
]);